import { render, staticRenderFns } from "./_top-header.vue?vue&type=template&id=18a6a22b&scoped=true&"
import script from "./_top-header.vue?vue&type=script&lang=js&"
export * from "./_top-header.vue?vue&type=script&lang=js&"
import style0 from "./_top-header.vue?vue&type=style&index=0&id=18a6a22b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a6a22b",
  null
  
)

export default component.exports